var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{staticClass:"card"},[_c('tab',{attrs:{"title":"SCHEDULE","icon":"fa fa-clock-o"}},[_c('Schedule')],1),_c('tab',{attrs:{"title":"COUPON","icon":"fa fa-ticket"}},[_c('Coupon')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }